var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1784_9904",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.359375,
    width: 25.5801,
    height: 25.5801,
    fill: "#548064"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1784_9904)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.359375,
    width: 25.5801,
    height: 25.5801,
    fill: "#1F477D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9975 -0.1875C22.1271 10.0775 17.908 18.454 12.7281 19.797C7.54821 21.1399 4.60575 18.6884 4.57443 13.2101C4.54312 7.73171 7.93214 4.51284 12.7281 6.33543C17.524 8.15801 25.5571 24.9775 25.5501 26.0001",
    stroke: "white",
    strokeWidth: 2.55801
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/LOGO.23c14130dd807d538fff372f7f75eb3c.svg";
export { ForwardRef as ReactComponent };